import React from 'react';

type TProps = {
  data: {
    description: string;
  };
  template: string;
};

export const Description = React.memo(({ data, template }: TProps) => {
  const prefixTemplateClass = `vitrine-template${template}`;

  return (
    <div
      className={`${prefixTemplateClass}__description`}
      dangerouslySetInnerHTML={{
        __html: data.description,
      }}
    />
  );
});
